import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Paper, Typography, Button, Box} from '@material-ui/core';
import clientGuide from './img/new-setupad-client-ui-guide.png';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(6),
    maxWidth: 600,
    textAlign: 'center',
  },
  errorImg: {
    display: 'block',
    width: '100%',
    maxWidth: 300,
    height: 'auto',
    marginBottom: theme.spacing(3),
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  message: {
    marginBottom: theme.spacing(4),
    opacity: 0.9,
  },
  button: {
    minWidth: 200,
  },
}));

function ErrorFallback() {
  const classes = useStyles();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper} elevation={0}>
        <img src={clientGuide} alt="Setupad Team" className={classes.errorImg} />
        <Typography variant="h4" className={classes.title}>
          Oops! Something went wrong.
        </Typography>
        <Typography variant="body1" className={classes.message}>
          We're sorry, but something unexpected happened. Our team has been notified and we're
          working on it.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleReload}
          className={classes.button}
        >
          Reload Page
        </Button>
      </Paper>
    </Box>
  );
}

export default ErrorFallback;
